import React, { PureComponent } from 'react';
import { Redirect } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FormGroup, InputGroup, FormControl, Button } from 'react-bootstrap';

import { withUser } from '../modules/User';
import LoadingButton from '../components/LoadingButton';

class SignIn extends PureComponent {
	state = {
		username: '',
		password: '',
	};

	handleUsername = ({ target: { value } }) =>
		this.setState({
			username: value.toUpperCase(),
		});

	handlePassword = ({ target: { value } }) =>
		this.setState({
			password: value.toUpperCase(),
		});

	login = (e) => {
		const id = e.target.user.value;
		const password = e.target.password.value;

		if (!id || id?.length === 0) {
			toast.warn('Preencha o usuário!');
		} else if (!password || password?.length === 0) {
			toast.warn('Preencha a senha!');
		} else {
			this.props.login(id, password);
		}
		e.preventDefault();
	};

	render() {
		const { isLogged = false, location, isLoading } = this.props;
		const { username, password } = this.state;
		const from = (location.state && location.state.from) || '/';
		if (isLogged) return <Redirect to={from} />;
		return (
			<div className="sign-in-container fade">
				<div className="sign-in-form">
					{/* <div className="title">
            <span>Login</span>
          </div> */}

					<form
						id="formContent"
						onSubmit={this.login}
						style={{ background: '#027bff' }}
					>
						<div>
							<img
								alt="Logotipo Vortex"
								src="assets/images/logos/vortex-logo-512px.png"
								style={{
									width: '50px',
									filter: 'drop-shadow(5px 5px 7px rgba(0, 0, 0, 0.3))',
								}}
							/>
							<img
								alt="Logomarca Vortex"
								src="assets/images/logos/logo-vortex-nome.png"
								style={{
									width: '150px',
									filter: 'drop-shadow(5px 5px 7px rgba(0, 0, 0, 0.3))',
								}}
							/>
						</div>
						<div style={{ marginBottom: '15px' }}>
							<p
								style={{
									color: '#FFF',
									float: 'left',
									fontSize: '12px',
									margin: '5px',
								}}
							>
								Powered by
							</p>
							<img
								alt="Logotipo Elemental"
								src="assets/images/logos/elemental-logo-branco-250px.png"
								style={{ width: '100px' }}
							/>
						</div>
						<FormGroup>
							<InputGroup>
								<InputGroup.Prepend>
									<InputGroup.Text>
										<i className="fa fa-user" />
									</InputGroup.Text>
								</InputGroup.Prepend>
								<FormControl
									type="text"
									name="user"
									placeholder="Usuário"
									onChange={this.handleUsername}
									value={username}
								/>
							</InputGroup>
							<InputGroup>
								<InputGroup.Prepend>
									<InputGroup.Text>
										<i className="fa fa-lock" />
									</InputGroup.Text>
								</InputGroup.Prepend>
								<FormControl
									type="password"
									name="password"
									className="form-control"
									placeholder="Senha"
									onChange={this.handlePassword}
									value={password}
								/>
							</InputGroup>
						</FormGroup>
						<LoadingButton
							type="submit"
							variant="primary"
							title="Conectar"
							style={{ background: '#FFFFFF', color: '#027bff' }}
							icon="fas fa-sign-in-alt"
							isLoading={isLoading}
						>
							{Button}
						</LoadingButton>
					</form>
				</div>
			</div>
		);
	}
}

export default withUser(SignIn);
